import React, { useEffect, useState } from 'react';
import './InstagramReels.css';

const InstagramReels = () => {
  const [loading, setLoading] = useState(true);
  const reels = [
    'https://www.instagram.com/reel/DTkmMVvAWB8/',
    'https://www.instagram.com/reel/DPjE2P3gQ0M/',
    'https://www.instagram.com/reel/DOn7YQVAbTo/',
    'https://www.instagram.com/reel/DUfzlKiAaSL/',
  ];

  useEffect(() => {
    let fallbackTimer;
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    const processEmbeds = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };

    script.onload = () => {
      processEmbeds();
      setTimeout(() => setLoading(false), 450);
    };

    // Reprocess embeds after a delay to ensure they load.
    fallbackTimer = setTimeout(() => {
      processEmbeds();
      setLoading(false);
    }, 2500);

    return () => {
      clearTimeout(fallbackTimer);
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="instagram-reels-section">
      <div className="instagram-reels-header">
        <h2>Follow Us on <strong>Instagram</strong></h2>
        <p>Check out our latest updates and offers</p>
      </div>

      {loading && (
        <div className="instagram-loader-overlay" role="status" aria-live="polite">
          <div className="instagram-loader-wrapper">
            <div className="instagram-loader-dot"></div>
            <div className="instagram-loader-dot"></div>
            <div className="instagram-loader-dot"></div>
            <span>Loading Instagram content...</span>
          </div>
        </div>
      )}

      <div className={`instagram-reels-container ${loading ? 'loading' : ''}`}>
        {reels.map((reel, index) => (
          <div key={index} className="instagram-reel-wrapper">
            <blockquote
              className="instagram-media"
              data-instgrm-captioned
              data-instgrm-permalink={reel}
              data-instgrm-version="14"
              style={{
                background: '#FFF',
                border: 0,
                borderRadius: '3px',
                boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
                margin: '1px',
                maxWidth: '540px',
                minWidth: '326px',
                padding: 0,
                width: 'calc(100% - 2px)',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InstagramReels;
